import { Theme, createTheme } from '@mui/material'
import { theme } from './muiTheme'

export const generatedTheme: Theme = {
  palette: {
    primary: {
      main: '#F6A501',
    },
    secondary: {
      main: '#1B1B1D',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: '20px / 50%',
        borderColor: '#1B1B1D !important',
        border: 'solid 1px #1B1B1D !important',
        height: '40px',
        paddingLeft: '30px',
        paddingRight: '30px',
        backgroundColor: '#1B1B1D',
        color: '#fff',
        '& .MuiSvgIcon-root': {
          color: '#fff',
        },
        '&:hover': {
          backgroundColor: '#fff',
          color: '#1B1B1D',
        },
        '&:hover .MuiSvgIcon-root': {
          color: '#1B1B1D',
        },
        '&.Mui-disabled': {
          backgroundColor: 'transparent !important',
          borderColor: '#eeeeee !important',
        },
        '&.Mui-disabled .MuiSvgIcon-root': {
          color: '#1B1B1D',
        },
      },
    },
    MuiList: {
      root: {
        backgroundColor: 'red',
        border: 0,
        boxShadow: '0px 5px 10px 2px #000000',
      },
    },
    MuiTabs: {
      root: {
        backgroundColor: '#fff',
        borderBottom: 'solid 2px #1B1B1D',
      },
      indicator: {
        display: 'none',
      },
    },
    MuiTableRow: {
      root: {
        borderRadius: '18px / 50%',
        backgroundColor: 'transparent !important', // override specificity
      },

    },
    MuiTableBody: {
      root: {
        '& .MuiTableRow-root:nth-of-type(2n+1) .MuiTableCell-root': {
          backgroundColor: '#BBBBBB33',
        },
      },
    },
    MuiTableCell: {
      root: {
        '&:first-child': {
          borderRadius: '18px / 50%',
          borderTopRightRadius: '0',
          borderBottomRightRadius: '0',
        },
        '&:last-child': {
          borderRadius: '18px / 50%',
          borderTopLeftRadius: '0',
          borderBottomLeftRadius: '0',
        },
      },
    },
    MuiInput: {
      root: {
        borderRadius: '20px / 50%',
      },
      input: {
        borderRadius: '20px / 50%',
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: '20px / 50%',
      },
    },
    MuiSvgIcon: {
      root: {
        color: theme.palette.text.primary,
      },
    },
  },
}

const defaultTheme: Theme = {
  // ...theme,
  ...generatedTheme,
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          borderRadius: '24px / 50%',
          margin: '5px',
          transition: 'background-color 150ms ease-out',
          flexDirection: 'row',
          '&.Mui-selected': {
            backgroundColor: '#F6A501',
          },
          '& > div': {
            color: theme.palette.text.primary,
          },
          '&.MuiButtonBase-root': {
            color: theme.palette.text.primary,
          },
        },
        wrapped: {
          borderRadius: '20px',
          minHeight: '40px',
        },
      },
    },
  },
}

export const crudeTheme: Theme = createTheme(defaultTheme)
